import React, { useState, useEffect } from 'react'
import HeroBanner from '../../component/HeroBanner'
import MembershipModal from '../../component/MembershipModal'
import { useGlobalContext } from '../../component/GlobalContext'
// "url('/assets/home-grid/family-fun-book-logo.jpg') "
const VendorSubscription = () => {
    const isProduction = process.env.REACT_APP_ENVIRONMENTL === 'production';
    console.log('REACT_APP_ENVIRONMENTL : '+isProduction);
    //MONTHLY
    const LIVE_MONTHLY_PERSONAL_PRICE_ID = 'price_1REUrhA7kr33YB4lBPIMt8io';
    const TEST_MONTHLY_PERSONAL_PRICE_ID = 'price_1REU7hBtU2OGzD7reVWY4zrQ';

    const LIVE_MONTHLY_STARTER_PRICE_ID = 'price_1REUtxA7kr33YB4lkDp9oHqQ';
    const TEST_MONTHLY_STARTER_PRICE_ID = 'price_1REUA0BtU2OGzD7rD7WiEQx0';

    const LIVE_MONTHLY_PREMIUM_PRICE_ID = 'price_1REUvBA7kr33YB4lkC0Rhkc3';
    const TEST_MONTHLY_PREMIUM_PRICE_ID = 'price_1REUBpBtU2OGzD7rrAqSAk7j';

    //YEARLY
    const LIVE_YEARLY_PERSONAL_PRICE_ID = 'price_1REUwvA7kr33YB4lO4FwVNGa';
    const TEST_YEARLY_PERSONAL_PRICE_ID = 'price_1REU7hBtU2OGzD7reVWY4zrQ';

    const LIVE_YEARLY_STARTER_PRICE_ID = 'price_1REUymA7kr33YB4llWUwO340';
    const TEST_YEARLY_STARTER_PRICE_ID = 'price_1REUA0BtU2OGzD7rD7WiEQx0';

    const LIVE_YEARLY_PREMIUM_PRICE_ID = 'price_1REUziA7kr33YB4ldkJhUYGn';
    const TEST_YEARLY_PREMIUM_PRICE_ID = 'price_1REUBpBtU2OGzD7rrAqSAk7j';


    const { globalUserVar, isAuthenticated, setIsAuthenticated, isActiveMember } = useGlobalContext();
    const [activeTab, setActiveTab] = useState('monthly-plan')
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        owner_first_name: "",
        owner_last_name: "",
        plan_type: "",
        plan_amount: "",
        plan_for: "",
        location_count: "",
        price_id: "",
        password: "",
    });
    useEffect(() => {
        window.scrollTo(0, 0)
        if (isAuthenticated) {
            let userObj = localStorage.getItem('userObj');
            if (userObj != null && userObj !== "") {
                let userJson = JSON.parse(userObj);
                setFormData((prevData) => ({
                    ...prevData,
                    email: userJson.email
                }));
            }
        }
    }, [isAuthenticated, showModal]);

    const handleTabChange = tab => {
        setActiveTab(tab)
    }
    const handlePlanClick = (plan_type, plan_amount, plan_for, location_count,price_id) => {
        // alert(plan_for);
        setFormData((prevData) => ({
            ...prevData,
            owner_first_name: "",
            owner_last_name: "",
            email: "",
            plan_type: plan_type,//anual,monthly
            plan_amount: plan_amount,
            plan_for: plan_for,//member,partner
            location_count: location_count,
            price_id: price_id,
            password: "",
        }));
        setShowModal(true)
    }

    return (
        <div className="w-full">
            <MembershipModal showModal={showModal} setShowModal={setShowModal} formData={formData} setFormData={setFormData} />
            <HeroBanner
                bannerImage="/assets/grid-img/family_in_restaurant.jpg"
                bannerTitle='Become a Preferred Business Partner of the Family Fun Club!'
                bannerDescription="Join our community of trusted businesses to connect with our Members online, in between our Family Festivals !" />
            <div className="container mx-auto py-9">

                <div className="membership-benefits-descriptions mx-10">
                    <h2 className='section-title text-center mb-4 '> Preferred Business Partner Benefits
                    </h2>
                    <ul className='  text-center ff-benefits-list mx-6'>
                        <>
                            <li><b>Business Directory Listing </b>  on the Family Fun AZ website</li>
                            <li>
                                Access to over <b> 30,000 Family Fun Club Members</b>  via Online Deals/Discounts
                            </li>
                            <li>
                                <b>Discounted Sponsorship</b> Fees for the Family Fun AZ Festivals <b>(20% Off)</b>
                            </li>
                            <li>
                                <b> Digital Promotion </b> on Monthly Family Fun AZ E-Blast Campaigns to Members
                            </li>
                        </>


                    </ul>
                </div>

                <div className="text-center mb-4">
                    <h4 className="section-title text-center my-6"> Preferred Business Partner Benefits</h4>
                </div>



                <div className="tabs-wrapper flex justify-center items-center">

                    <div className="tabs-container">
                        <div className="flex bg-white shadow-md rounded ">
                            <button
                                className={` membership-tab ${activeTab === 'monthly-plan' ? 'membership-active-tab' : ''}`}

                                onClick={() => handleTabChange('monthly-plan')}
                            >
                                Monthly
                            </button>
                            <button
                                className={`membership-tab ${activeTab === 'anual-plan' ? 'membership-active-tab' : ''}`}

                                onClick={() => handleTabChange('anual-plan')}
                            >
                                Annually
                            </button>


                        </div>
                    </div>
                </div>


                <div className="membership-detail-wrapper my-8">

                    <div className="membership-cards flex items-center justify-center  pb- flex-col md:flex-row flex-wrap">
                        {activeTab === "anual-plan" && (<>
                            {/* card 1  */}
                            <div className={`w-full md:w-[30%] h-[400px] border border-gray-200 rounded-lg shadow-lg p-6 bg-white flex flex-col justify-between membership-card-size`}>
                                {/* ${activeTab === "plan-a" ? "fade-in-active" : ""} */}
                                {/* <!-- Card Header --> */}

                                <div className="membership-card-header  ">
                                    <div className="mb-1">
                                        <span className="inline-block bg-gray-100 p-2 rounded-full">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.71 5.57L14.44 0.29C14.26 0.1 14 0 13.72 0H6.28C6 0 5.74 0.1 5.56 0.29L0.29 5.57C0.1 5.74 0 6 0 6.28V13.72C0 14 0.1 14.26 0.29 14.44L5.56 19.71C5.74 19.9 6 20 6.28 20H13.72C14 20 14.26 19.9 14.44 19.71L19.71 14.44C19.9 14.26 20 14 20 13.72V6.28C20 6 19.9 5.74 19.71 5.57ZM18.16 13.33L13.33 18.16H6.67L1.84 13.33V6.67L6.67 1.84H13.33L18.16 6.67V13.33Z" fill="black" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div className="">
                                        <h4 className="text-lg font-semibold  mb-[5px] md:mb-2">Personal (1 Location)</h4>
                                        <p className="text-[#B4B1B8] font-normal">Pay your Membership Fee Annually (No Contract Required - cancel anytime) </p>
                                    </div>
                                </div>

                                {/* <!-- Card Body --> */}
                                <div className="membership-card-body  mb-6">
                                    <p className="my-[5px] md:my-0 text-xl md:text-2xl xl:text-4xl font-bold text-gray-800">
                                        $99.00<span className="text-xl text-gray-400  separation-icon">  ($8.25)   Month </span>
                                    </p>
                                </div>

                                {/* <!-- Card Footer --> */}
                                <div className="membership-card-footer ">

                                    <button
                                        className="w-full text-center  text-white py-3 rounded-lg theme-button font-semibold transition"
                                        onClick={() => handlePlanClick('annual', 99.00, 'partner', 1,isProduction ? LIVE_YEARLY_PERSONAL_PRICE_ID : TEST_YEARLY_PERSONAL_PRICE_ID)}
                                    >
                                        Subscribe Now
                                    </button>
                                </div>
                            </div>
                            {/* card 2  */}
                            <div className="w-[30%] h-[400px] border border-gray-200 rounded-lg shadow-lg p-6  flex flex-col justify-between plans-card membership-card-size">
                                {/* <!-- Card Header --> */}

                                <div className="membership-card-title  ">
                                    <div className="membership-card-header  flex items-center justify-between mb-1">
                                        <span className="inline-block bg-[#5906DB] p-2 rounded-full">
                                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.7275 6.05235C16.6746 5.89931 16.5785 5.7649 16.4508 5.6654C16.3231 5.5659 16.1693 5.5056 16.008 5.4918L11.2475 4.79739L9.11405 0.471957C9.04554 0.330505 8.93857 0.211211 8.8054 0.127741C8.67223 0.0442708 8.51824 0 8.36107 0C8.2039 0 8.04991 0.0442708 7.91674 0.127741C7.78357 0.211211 7.6766 0.330505 7.60809 0.471957L5.47466 4.78902L0.714181 5.4918C0.559337 5.51381 0.413764 5.57878 0.293979 5.67934C0.174194 5.7799 0.084994 5.91202 0.0365024 6.06071C-0.00788554 6.20602 -0.0118688 6.36066 0.02498 6.50806C0.0618288 6.65545 0.138119 6.79003 0.245662 6.89735L3.70099 10.2439L2.86435 14.996C2.83448 15.1529 2.85012 15.315 2.90942 15.4633C2.96872 15.6115 3.0692 15.7397 3.199 15.8327C3.32552 15.9231 3.47474 15.9765 3.62991 15.9868C3.78509 15.9972 3.94007 15.9641 4.07747 15.8912L8.36107 13.6574L12.6279 15.8996C12.7454 15.9658 12.878 16.0004 13.0128 16C13.19 16.0006 13.3629 15.945 13.5064 15.841C13.6362 15.7481 13.7367 15.6199 13.796 15.4716C13.8553 15.3234 13.8709 15.1612 13.8411 15.0044L13.0044 10.2523L16.4597 6.90572C16.5805 6.80338 16.6698 6.66887 16.7172 6.51781C16.7646 6.36675 16.7682 6.20535 16.7275 6.05235ZM11.5821 9.39891C11.484 9.49381 11.4106 9.61128 11.3683 9.74107C11.326 9.87086 11.3161 10.009 11.3395 10.1435L11.9419 13.649L8.79612 11.9758C8.67508 11.9113 8.54004 11.8776 8.4029 11.8776C8.26576 11.8776 8.13073 11.9113 8.00968 11.9758L4.86392 13.649L5.4663 10.1435C5.48967 10.009 5.47978 9.87086 5.43749 9.74107C5.3952 9.61128 5.32179 9.49381 5.22367 9.39891L2.71375 6.88899L6.236 6.37864C6.37154 6.35978 6.50038 6.30797 6.61124 6.22775C6.72209 6.14752 6.81158 6.04133 6.87185 5.91848L8.36107 2.73088L9.93395 5.92685C9.99423 6.0497 10.0837 6.15589 10.1946 6.23612C10.3054 6.31634 10.4343 6.36815 10.5698 6.387L14.0921 6.89735L11.5821 9.39891Z" fill="white" />
                                            </svg>
                                        </span>
                                        <div className="card-highlight-text font-bold"> Best Deal</div>
                                    </div>
                                    <div className="">
                                        <h4 className="text-lg font-semibold  mb-[5px] md:mb-2">Starter (2-5 Locations)</h4>
                                        <p className=" font-normal">Expand your coverage up to 5 locations with tailored perks.</p>
                                    </div>
                                </div>

                                {/* <!-- Card Body --> */}
                                <div className="membership-card-body  mb-6">
                                    <p className="my-[5px] md:my-0 text-xl md:text-2xl xl:text-4xl font-bold  ">
                                        $199.99<span className="text-xl text-gray-400 separation-icon">  $(16.66)  Month </span>
                                    </p>
                                </div>



                                {/* <!-- Card Footer --> */}
                                <div className="membership-card-footer ">

                                    <button className="w-full text-center py-3 rounded-lg plans-button font-semibold transition"
                                        onClick={() => handlePlanClick('annual', 199.99, 'partner', 5,isProduction ? LIVE_YEARLY_STARTER_PRICE_ID : TEST_YEARLY_STARTER_PRICE_ID)}
                                    >
                                        Subscribe Now
                                    </button>
                                </div>
                            </div>
                            {/* card 3  */}
                            <div className={`w-[30%] h-[400px] border border-gray-200 rounded-lg shadow-lg p-6 bg-white flex flex-col justify-between membership-card-size`}>
                                {/* ${activeTab === "plan-a" ? "fade-in-active" : ""} */}
                                {/* <!-- Card Header --> */}

                                <div className="membership-card-header  ">
                                    <div className="mb-1">
                                        <span className="inline-block bg-gray-100 p-2 rounded-full">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.71 5.57L14.44 0.29C14.26 0.1 14 0 13.72 0H6.28C6 0 5.74 0.1 5.56 0.29L0.29 5.57C0.1 5.74 0 6 0 6.28V13.72C0 14 0.1 14.26 0.29 14.44L5.56 19.71C5.74 19.9 6 20 6.28 20H13.72C14 20 14.26 19.9 14.44 19.71L19.71 14.44C19.9 14.26 20 14 20 13.72V6.28C20 6 19.9 5.74 19.71 5.57ZM18.16 13.33L13.33 18.16H6.67L1.84 13.33V6.67L6.67 1.84H13.33L18.16 6.67V13.33Z" fill="black" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div className="">
                                        <h4 className="text-lg font-semibold  mb-[5px] md:mb-2">Premium (5-10 Locations)</h4>
                                        <p className="text-[#B4B1B8] font-normal">Enjoy full benefits for up to 10 locations with ease.</p>
                                    </div>
                                </div>

                                {/* <!-- Card Body --> */}
                                <div className="membership-card-body  mb-6">
                                {/* my-[5px] md:my-0 text-xl md:text-2xl xl:text-4xl font-bold   */}

                                    <p className="my-[5px] md:my-0 text-xl md:text-2xl xl:text-4xl font-bold  ">
                                        $299.00<span className="text-xl text-gray-400 separation-icon"> $(24.92)   Month</span>
                                    </p>
                                </div>

                                {/* <!-- Card Footer --> */}
                                <div className="membership-card-footer ">
                                    <button className="w-full text-center  text-white py-3 rounded-lg theme-button font-semibold transition"
                                        onClick={() => handlePlanClick('annual', 299.00, 'partner', 10,isProduction ? LIVE_YEARLY_PREMIUM_PRICE_ID : TEST_YEARLY_PREMIUM_PRICE_ID)}>
                                        Subscribe Now
                                    </button>
                                </div>
                            </div>
                        </>)}


                        {activeTab === "monthly-plan" && (<>
                            {/* card 1  */}
                            <div className={`w-full md:w-[30%] h-[400px] border border-gray-200 rounded-lg shadow-lg p-6 bg-white flex flex-col justify-between membership-card-size`}>
                                {/* ${activeTab === "plan-a" ? "fade-in-active" : ""} */}
                                {/* <!-- Card Header --> */}

                                <div className="membership-card-header  ">
                                    <div className="mb-1">
                                        <span className="inline-block bg-gray-100 p-2 rounded-full">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.71 5.57L14.44 0.29C14.26 0.1 14 0 13.72 0H6.28C6 0 5.74 0.1 5.56 0.29L0.29 5.57C0.1 5.74 0 6 0 6.28V13.72C0 14 0.1 14.26 0.29 14.44L5.56 19.71C5.74 19.9 6 20 6.28 20H13.72C14 20 14.26 19.9 14.44 19.71L19.71 14.44C19.9 14.26 20 14 20 13.72V6.28C20 6 19.9 5.74 19.71 5.57ZM18.16 13.33L13.33 18.16H6.67L1.84 13.33V6.67L6.67 1.84H13.33L18.16 6.67V13.33Z" fill="black" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div className="">
                                        <h4 className="text-lg font-semibold  mb-[5px] md:mb-2">Personal (1 Location)</h4>
                                        <p className="text-[#B4B1B8] font-normal">Pay your Membership Fee Monthly (No Contract
                                            Required - cancel anytime)</p>
                                    </div>
                                </div>

                                {/* <!-- Card Body --> */}
                                <div className="membership-card-body  mb-6">
                                    <p className="my-[5px] md:my-0 text-xl md:text-2xl xl:text-4xl font-bold text-gray-800">
                                        $9.99<span className="text-xl text-gray-400 separation-icon"> Month</span>
                                    </p>
                                </div>

                                {/* <!-- Card Footer --> */}
                                <div className="membership-card-footer ">
                                    <p className="text-gray-500 mb-1 lg:mb-4">
                                        <span>$99.00 / year</span> <span className="text-sm text-green-500">(save ~$21)</span>
                                    </p>
                                    <button className="w-full text-center  text-white py-3 rounded-lg theme-button font-semibold transition"
                                        onClick={() => handlePlanClick('month', 9.99, 'partner', 1,isProduction ? LIVE_MONTHLY_PERSONAL_PRICE_ID : TEST_MONTHLY_PERSONAL_PRICE_ID)}>
                                        Subscribe Now
                                    </button>
                                </div>
                            </div>
                            {/* card 2 */}
                            <div className={`w-full md:w-[30%] h-[400px] border border-gray-200 rounded-lg shadow-lg p-0 md:p-6 flex flex-col justify-between plans-card membership-card-size`}>
                                {/* ${activeTab === "plan-a" ? "fade-in-active" : ""} */}
                                {/* <!-- Card Header --> */}

                                <div className="membership-card-header  ">
                                    <div className="mb-1">

                                        <span className="inline-block bg-[#5906DB] p-2 rounded-full">
                                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.7275 6.05235C16.6746 5.89931 16.5785 5.7649 16.4508 5.6654C16.3231 5.5659 16.1693 5.5056 16.008 5.4918L11.2475 4.79739L9.11405 0.471957C9.04554 0.330505 8.93857 0.211211 8.8054 0.127741C8.67223 0.0442708 8.51824 0 8.36107 0C8.2039 0 8.04991 0.0442708 7.91674 0.127741C7.78357 0.211211 7.6766 0.330505 7.60809 0.471957L5.47466 4.78902L0.714181 5.4918C0.559337 5.51381 0.413764 5.57878 0.293979 5.67934C0.174194 5.7799 0.084994 5.91202 0.0365024 6.06071C-0.00788554 6.20602 -0.0118688 6.36066 0.02498 6.50806C0.0618288 6.65545 0.138119 6.79003 0.245662 6.89735L3.70099 10.2439L2.86435 14.996C2.83448 15.1529 2.85012 15.315 2.90942 15.4633C2.96872 15.6115 3.0692 15.7397 3.199 15.8327C3.32552 15.9231 3.47474 15.9765 3.62991 15.9868C3.78509 15.9972 3.94007 15.9641 4.07747 15.8912L8.36107 13.6574L12.6279 15.8996C12.7454 15.9658 12.878 16.0004 13.0128 16C13.19 16.0006 13.3629 15.945 13.5064 15.841C13.6362 15.7481 13.7367 15.6199 13.796 15.4716C13.8553 15.3234 13.8709 15.1612 13.8411 15.0044L13.0044 10.2523L16.4597 6.90572C16.5805 6.80338 16.6698 6.66887 16.7172 6.51781C16.7646 6.36675 16.7682 6.20535 16.7275 6.05235ZM11.5821 9.39891C11.484 9.49381 11.4106 9.61128 11.3683 9.74107C11.326 9.87086 11.3161 10.009 11.3395 10.1435L11.9419 13.649L8.79612 11.9758C8.67508 11.9113 8.54004 11.8776 8.4029 11.8776C8.26576 11.8776 8.13073 11.9113 8.00968 11.9758L4.86392 13.649L5.4663 10.1435C5.48967 10.009 5.47978 9.87086 5.43749 9.74107C5.3952 9.61128 5.32179 9.49381 5.22367 9.39891L2.71375 6.88899L6.236 6.37864C6.37154 6.35978 6.50038 6.30797 6.61124 6.22775C6.72209 6.14752 6.81158 6.04133 6.87185 5.91848L8.36107 2.73088L9.93395 5.92685C9.99423 6.0497 10.0837 6.15589 10.1946 6.23612C10.3054 6.31634 10.4343 6.36815 10.5698 6.387L14.0921 6.89735L11.5821 9.39891Z" fill="white" />
                                            </svg>
                                        </span>

                                    </div>

                                    <div className="">
                                        <h4 className="text-lg font-semibold  mb-[5px] md:mb-2">Starter (2-5 Location)</h4>
                                        <p className="text-[#B4B1B8] font-normal">Expand your coverage up to 5 locations with tailored perks.</p>
                                    </div>
                                </div>

                                {/* <!-- Card Body --> */}
                                <div className="membership-card-body  mb-6">
                                    <p className="my-[5px] md:my-0 text-xl md:text-2xl xl:text-4xl font-bold  ">
                                        $19.99<span className="text-xl text-gray-400 separation-icon"> Month</span>
                                    </p>
                                </div>

                                {/* <!-- Card Footer --> */}
                                <div className="membership-card-footer ">
                                    <p className="text-gray-300 mb-1 lg:mb-4">
                                        <span>$199.00 / year</span> <span className="text-sm text-gray-300">(save ~$41)</span>
                                    </p>
                                    <button className="w-full text-center  text-white py-3 rounded-lg plans-button plans-button font-semibold transition"
                                        onClick={() => handlePlanClick('month', 19.99, 'partner', 5,isProduction ? LIVE_MONTHLY_STARTER_PRICE_ID : TEST_MONTHLY_STARTER_PRICE_ID)}>
                                        Subscribe Now
                                    </button>
                                </div>
                            </div>

                            {/* card 3  */}
                            <div className={`w-full md:w-[30%] h-[400px] border border-gray-200 rounded-lg shadow-lg p-6 bg-white flex flex-col justify-between membership-card-size`}>
                                {/* ${activeTab === "plan-a" ? "fade-in-active" : ""} */}
                                {/* <!-- Card Header --> */}

                                <div className="membership-card-header  ">
                                    <div className="mb-1">
                                        <span className="inline-block bg-gray-100 p-2 rounded-full">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.71 5.57L14.44 0.29C14.26 0.1 14 0 13.72 0H6.28C6 0 5.74 0.1 5.56 0.29L0.29 5.57C0.1 5.74 0 6 0 6.28V13.72C0 14 0.1 14.26 0.29 14.44L5.56 19.71C5.74 19.9 6 20 6.28 20H13.72C14 20 14.26 19.9 14.44 19.71L19.71 14.44C19.9 14.26 20 14 20 13.72V6.28C20 6 19.9 5.74 19.71 5.57ZM18.16 13.33L13.33 18.16H6.67L1.84 13.33V6.67L6.67 1.84H13.33L18.16 6.67V13.33Z" fill="black" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div className="">
                                        <h4 className="text-lg font-semibold  mb-[5px] md:mb-2">Premium (5-10 Location)</h4>
                                        <p className="text-[#B4B1B8] font-normal">Enjoy full benefits for up to 10 locations with ease.</p>
                                    </div>
                                </div>

                                {/* <!-- Card Body --> */}
                                <div className="membership-card-body  mb-6">
                                    <p className="my-[5px] md:my-0 text-xl md:text-2xl xl:text-4xl font-bold text-gray-800">
                                        $29.99<span className="text-xl text-gray-400 separation-icon"> Month</span>
                                    </p>
                                </div>

                                {/* <!-- Card Footer --> */}
                                <div className="membership-card-footer ">
                                    <p className="text-gray-500 mb-1 lg:mb-4">
                                        <span>$299.00 / year</span> <span className="text-sm text-green-500">(save ~$61)</span>
                                    </p>
                                    <button className="w-full text-center  text-white py-3 rounded-lg theme-button font-semibold transition"
                                        onClick={() => handlePlanClick('month', 29.99, 'partner', 10,isProduction ? LIVE_MONTHLY_PREMIUM_PRICE_ID : TEST_MONTHLY_PREMIUM_PRICE_ID)}>
                                        Subscribe Now
                                    </button>
                                </div>
                            </div>
                        </>)}
                    </div>



                </div>
            </div>
        </div>
    )
}

export default VendorSubscription